import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ASubAdminsState, Timing, ErrorTrigger } from 'store/types';
import ASubAdmin from '../../models/Admin/ASubAdmin';
import { extractErrorMessageFromResponse } from 'lib/utils/redux';

const initialState: ASubAdminsState = {
	list: [],
	error: '',
	loading: false,
	errorTrigger: 0,
	updatedAt: Timing.now(),
};

const slice = createSlice({
	name: 'aSubAdmins',
	initialState,
	reducers: {
		setIsLoading: (state, action: PayloadAction<boolean>) => {
			state.loading = action.payload;
		},
		setErrorTrigger: (state, action: PayloadAction<ErrorTrigger>) => {
			state.loading = false;
			state.errorTrigger = Timing.now();
			state.error = extractErrorMessageFromResponse(action.payload);
		},
		setList: (state, action: PayloadAction<ASubAdmin[]>) => {
			state.loading = false;
			state.list = action.payload;
		},
		handleCreate: (state, action: PayloadAction<ASubAdmin>) => {
			state.loading = false;
			state.list = [...state.list, action.payload];
		},
		handleUpdate: (state, action: PayloadAction<ASubAdmin>) => {
			state.loading = false;
			const index = state.list.findIndex((element) => element.id === action.payload.id);
			if (index === -1) return;
			state.list[index] = action.payload;
		},
	},
});

export const { setList, handleCreate, handleUpdate, setIsLoading, setErrorTrigger } = slice.actions;

export default slice.reducer;
